import { GiftCardsUtilService } from '@core/services/ib-gift-cards-utils.service';
import { RedirectionLandingService } from '@core/services/ib-gift-cards-redirection-service';
import { GiftCardsConfigurationService } from '@src/app/features/pages/configuration/services/ib-gift-cards-configuration/ib-gift-cards-configuration-service';
import angular from 'angular';
import { GiftCardsDatalayerService } from '@src/app/core/services/ib-gift-cards-datalayer-service';
import {GiftCardsRouterConstantsType} from '@src/app/core/routing/ib-gift-cards-router-constants';
const componentOptions = {
    bindings: {},
    controllerAs: 'giftCardsConfigurationCtrl',
    templateUrl: ['GiftCardsAppConstants', (GiftCardsAppConstants: GiftCardsAppConstant): string => `${GiftCardsAppConstants.templatesRoute}ib-gift-cards-configuration-view.html`]
};
const componentInfo = {
    module: 'ib-gift-cards-configuration-module',
    selector: 'ibGiftCardsConfiguration',
    inject:['$location', '$scope',
        '$timeout',  'localStorageService',
        'GiftCardsAppConstants',
        'GiftCardsUtilService',  'GiftCardsConfigurationService',
        'CommonsModalService', 'DatalayerUtilsService',  'RedirectionLandingService',
        'GiftCardsRouterConstants',  '$translate',
        '$filter', 'CommonsGetWcsPhonesService', 'IbCAuthTokenService', '$rootScope', 'CommonsKeepAliveUtilsService', 'IbCPermanentUserService', 'DigitalDataService',
        'GiftCardsDatalayerService', 'IbCNewPaymentAvailiabilityService'],
    required: ['ib-gift-cards-configuration-form-module', 'ib-gift-cards-service-module']
};



export class ibGiftCardsConfiguration implements ng.IController {
    public model: Types.ConfigurationModel;
    constructor (
        private $location: ng.ILocationService,
        private $scope: angular.IScope,
        private $timeout: ng.ITimeoutService,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private GiftCardsAppConstants: GiftCardsAppConstant,
        private GiftCardsUtilService: GiftCardsUtilService,
        private GiftCardsConfigurationService: GiftCardsConfigurationService,
        private CommonsModalService: any,
        private DatalayerUtilsService: any,
        private RedirectionLandingService: RedirectionLandingService,
        private GiftCardsRouterConstants: GiftCardsRouterConstantsType,
        private $translate: angular.translate.ITranslateService,
        private $filter: angular.IFilterService,
        private CommonsGetWcsPhonesService: any,
        private IbCAuthTokenService: any,
        private $rootScope: CommonsRootScope,
        private CommonsKeepAliveUtilsService: CommonsKeepAliveUtilsService,
        private IbCPermanentUserService: IbCPermanentUserService,
        private DigitalDataService: any,
        private GiftCardsDatalayerService: GiftCardsDatalayerService,
        private IbCNewPaymentAvailiabilityService: IbCNewPaymentAvailiabilityService) {
    }
    active = async (): Promise<any> => {
        const isNewPayment = this.localStorageService.get('isNewPayment');
        const paymentStatus = this.GiftCardsUtilService.getParameterByName(this.GiftCardsAppConstants.nameParameters.paymentStatus);
        const componentType = this.GiftCardsUtilService.getParameterByName(this.GiftCardsAppConstants.nameParameters.componentType);
        const redirectStatus = !!(paymentStatus === this.GiftCardsAppConstants.PAYMENTS.PAYMENTSTATUSOK || paymentStatus === this.GiftCardsAppConstants.PAYMENTS.PAYMENTSTATUSKO || componentType);
        const redirectionPaymentCallback: any = this.localStorageService.get('redirectionPaymentCallback');
        const isAfterLoginPermanentUser = this.IbCPermanentUserService.isAfterLoginPermanentUser();
        const isTransferNewPayment = redirectStatus && componentType === this.GiftCardsAppConstants.PAYMENTS.AFOP_SOFORT && isNewPayment;
        const shouldRedirectToPayments = (redirectionPaymentCallback && redirectionPaymentCallback.status && redirectStatus) || isAfterLoginPermanentUser || isTransferNewPayment;
        if (shouldRedirectToPayments) {
            this.CommonsKeepAliveUtilsService.initKeepAlive();
            this.localStorageService.set('nextStepAllowed', true);
            if(!isAfterLoginPermanentUser && !isNewPayment) {
                angular.extend(redirectionPaymentCallback, {
                    redirectStatus: redirectStatus,
                    paymentStatus: paymentStatus === this.GiftCardsAppConstants.PAYMENTS.PAYMENTSTATUSKO ? false : paymentStatus === this.GiftCardsAppConstants.PAYMENTS.PAYMENTSTATUSOK || componentType || false
                });
                this.localStorageService.set('redirectionPaymentCallback', redirectionPaymentCallback);
                const datalayer_back = this.localStorageService.get('datalayer_general_Back');
                if (datalayer_back) {
                    this.DatalayerUtilsService.updateDatalayerWithQuadrigam(null, datalayer_back, this.GiftCardsUtilService.isUserLogged());
                }
            }
            this.GiftCardsDatalayerService.updateStepWithQuadrigam();
            const isNewPaymentAvailiability = await this.IbCNewPaymentAvailiabilityService.isNewPaymentAvailiability();
            const paymentsURI = isNewPaymentAvailiability ? this.GiftCardsAppConstants.PAGES_ROUTES.NEWPAYMENTS : this.GiftCardsAppConstants.PAGES_ROUTES.PAYMENTS;
            this.$location.path(paymentsURI);
        } else {
            this.CommonsModalService.showWaitingModal('ib-modal-loading-plane', 'ib-modals ib-modals--transparent ib-modals--loading-page', true);
            this.IbCAuthTokenService.getAnonymousToken().then(() => {
                this.CommonsGetWcsPhonesService.getPhoneByCode(this.GiftCardsAppConstants.WCS.PHONE_TYPES.SALES).then(() => {
                    this.$rootScope.phonesList = this.localStorageService.get('phonesList') || {};
                });
                this.nextStep();
            }, () => {
                this.$location.path('/error');
            });
            this.localStorageService.remove('headerModel');

        }

    };
    $onInit = () => {
        this.active();
    };
    checkGroupAvailability = (availabilityResponse: Types.AvailabilityGiftCards) => {
        //return availabilityResponse.groupFixedPrices || !(Array.isArray(availabilityResponse.groupFixedPrices) && (availabilityResponse.groupFixedPrices.length === 0));
        let groupAvailability = true;
        if(!availabilityResponse.groupFixedPrices || (availabilityResponse.groupFixedPrices && availabilityResponse.groupFixedPrices.length === 0)) groupAvailability = false;
        return groupAvailability;
    };
    checkGiftCardAvailability = (availabilityResponse) => {
        if(!availabilityResponse.fixedPrices || (availabilityResponse.fixedPrices && availabilityResponse.fixedPrices.length === 0)) this.$location.path(this.GiftCardsRouterConstants.PAGES_URL.GIFTCARD_ERROR);
    };
    nextStep = () => {
        this.localStorageService.remove('redirectionPaymentCallback');
        this.localStorageService.remove('datalayer_general_Back');
        this.GiftCardsDatalayerService.updateStepWithQuadrigam();
        this.CommonsModalService.showWaitingModal('ib-modal-loading-plane', 'ib-modals ib-modals--transparent ib-modals--loading-page', true);
        this.GiftCardsConfigurationService.getAvailability().then((availabilityResponse: Types.AvailabilityGiftCards) => {
            this.model = this.GiftCardsConfigurationService.initializeModel();
            this.model.importInfo = availabilityResponse;
            this.checkGiftCardAvailability(availabilityResponse);
            this.model.groupAvailability = this.checkGroupAvailability(availabilityResponse);
            this.DigitalDataService.addDigitalDataInfo({GiftCardCampaign: availabilityResponse?.conditionInfo?.campaigns[0]?.commercialCode ? availabilityResponse?.conditionInfo?.campaigns[0]?.commercialCode : 'sin campaña'});
            this.model.importGift = availabilityResponse.fixedPrices[0];
            this.model.themeGift.theme = this.GiftCardsAppConstants.THEME;
            this.model.destinataryInfo.message = this.$filter('translate')('GIFT_CARD_PREMESSAGE_RECEIVER');
            this.$timeout(() => {
                this.CommonsModalService.finishWaiting();
                this.CommonsModalService.closeAllCurrentModals();
                this.$rootScope.$broadcast('sendUpdateToMonetate');
                this.$rootScope.$broadcast('updateDatalayer');            
                this.$rootScope.$broadcast('updateDigitalData');
            });
        }, (error: any) => {
            this.$timeout(() => {
                this.CommonsModalService.finishWaiting();
                this.CommonsModalService.closeAllCurrentModals();
                this.$location.path(this.GiftCardsRouterConstants.PAGES_URL.GIFTCARD_ERROR);
            });

        }).catch(() => {
            this.$timeout(() => {
                this.CommonsModalService.finishWaiting();
                this.CommonsModalService.closeAllCurrentModals();
            });
        });
    };
}
try {
    const mod = angular.module(componentInfo.module);
    ibGiftCardsConfiguration.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibGiftCardsConfiguration })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibGiftCardsConfiguration.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibGiftCardsConfiguration })
    );
}
